import { useGraphqlQuery } from "@harea/component";
import { TWorkingDaysResponse } from "@harea/component";
import moment from "moment";
import { WorkingDayListQuery } from "../queries/WorkingDayListQuery";

export const useWorkingDayListQuery = (
    suspense?: boolean,
    year?: number,
    personnelId?: number
) => {
    return useGraphqlQuery<WorkingDayListQuery, TWorkingDaysResponse>(
        new WorkingDayListQuery({
            data: {
                year: year ?? moment().year(),
                ...(personnelId ? { personnelGroup: { personnels: {id : personnelId } } } : {})
            },
        }),
        { suspense }
    );
};
